export type DocsNavEntry = {
  path: string;
  labelKey: string;
};

export const DOCS_NAV_ORDER: DocsNavEntry[] = [
  { path: "/docs/kira-arts/getting-started", labelKey: "sidebar.installation" },
  { path: "/docs/kira-arts/cards/profile", labelKey: "sidebar.profileCard" },
  { path: "/docs/kira-arts/cards/welcome-leave", labelKey: "sidebar.welcomeLeave" },
  { path: "/docs/kira-arts/cards/levelup", labelKey: "sidebar.levelUpCard" },
  { path: "/docs/kira-arts/cards/achievement", labelKey: "sidebar.achievementCard" },
  { path: "/docs/kira-arts/cards/ship", labelKey: "sidebar.shipCard" },
  { path: "/docs/kira-arts/cards/leaderboard", labelKey: "sidebar.leaderboardCard" },
  { path: "/docs/kira-arts/cards/now-playing", labelKey: "sidebar.nowPlayingCard" },
  { path: "/docs/kira-arts/cards/giveaway", labelKey: "sidebar.giveawayCard" },
  { path: "/docs/kira-arts/color-system", labelKey: "sidebar.colorRules" },
  { path: "/docs/kira-arts/playground", labelKey: "sidebar.playgroundLink" },
];
